export default "__VITE_ASSET__q1MeDw85__"